"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadingDateTime = exports.getBackdatedDaysToToday = exports.validateDate = exports.ClientSideDateError = exports.getMeterReadAnalyticsData = exports.mapApiErrorCode = exports.allErrorsExpected = exports.getSuccessRedirectLink = exports.validateInput = exports.formatMeterType = exports.ClientSideReadingError = void 0;
var date_fns_1 = require("date-fns");
var utils_1 = require("../../../transfers/utils");
var SERVER_SIDE_ERRORS = {
    TOO_HIGH: {
        errorCode: 'TOO_HIGH',
        message: 'errorsServerTooHigh',
        multiRateMessage: 'errorsServerTooHighMultiRate',
    },
    TOO_LOW: {
        errorCode: 'TOO_LOW',
        message: 'errorsServerTooLow',
        multiRateMessage: 'errorsServerTooLowMultiRate',
    },
};
var FALLBACK_ERROR = {
    errorCode: 'OTHER',
    message: 'errorsFallback',
    multiRateMessage: 'errorsFallback',
};
var ClientSideReadingError;
(function (ClientSideReadingError) {
    ClientSideReadingError["NonNumericChars"] = "errorsClientNonNumeric";
    ClientSideReadingError["NonNumericCharsWithoutDigits"] = "errorsClientNonNumericWithoutDigits";
    ClientSideReadingError["TooManyDigits"] = "errorsClientTooManyDigits";
    ClientSideReadingError["Decimal"] = "errorsClientDecimal";
    ClientSideReadingError["NegativeValue"] = "errorsClientNegativeValue";
    ClientSideReadingError["EmptyInput"] = "errorsClientEmpty";
})(ClientSideReadingError || (exports.ClientSideReadingError = ClientSideReadingError = {}));
var formatMeterType = function (rawMeterType) {
    var lc = rawMeterType.toLowerCase();
    if (lc.startsWith('s1')) {
        return 'smets1';
    }
    if (lc.startsWith('s2')) {
        return 'smets2';
    }
    return 'trad';
};
exports.formatMeterType = formatMeterType;
var validateInput = function (reading, meterDigits) {
    if (meterDigits === void 0) { meterDigits = null; }
    if (reading === null) {
        return {
            message: ClientSideReadingError.EmptyInput,
            errorName: 'reading-empty',
        };
    }
    if (isNaN(reading)) {
        return meterDigits
            ? {
                message: ClientSideReadingError.NonNumericChars,
                errorName: 'reading-non-numeric',
            }
            : {
                message: ClientSideReadingError.NonNumericCharsWithoutDigits,
                errorName: 'reading-non-numeric-without-digits',
            };
    }
    var readingAsString = "".concat(reading);
    if (readingAsString.includes('.')) {
        return {
            message: ClientSideReadingError.Decimal,
            errorName: 'reading-decimal',
        };
    }
    if (meterDigits && readingAsString.length > meterDigits) {
        return {
            message: ClientSideReadingError.TooManyDigits,
            errorName: 'reading-too-many-digits',
        };
    }
    if (reading < 1) {
        return {
            message: ClientSideReadingError.NegativeValue,
            errorName: 'reading-negative-value',
        };
    }
    return null;
};
exports.validateInput = validateInput;
var params = function (object) {
    return new URLSearchParams(object).toString();
};
var toSingleRateRedirectLink = function (basePath, fuel, meterReading, isPending, isOMR, supplyIndex, readingDate, hasImgError, msn, meterPhotoName) {
    if (readingDate === void 0) { readingDate = ''; }
    var values = __assign({ fuel: fuel, meterReading: meterReading, readingDate: readingDate !== ''
            ? (0, date_fns_1.format)(new Date(readingDate), 'yyyy-MM-dd')
            : (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), 'yyyy-MM-dd'), isPending: isPending, isOMR: isOMR }, (supplyIndex ? { supplyIndex: supplyIndex } : {}));
    if (msn) {
        values.msn = msn;
    }
    if (meterPhotoName) {
        values.meterPhotoName = meterPhotoName;
    }
    if (hasImgError) {
        values.photoError = hasImgError;
    }
    return "".concat(basePath, "?") + params(values);
};
var toMultiRateRedirectLink = function (basePath, fuel, peakMeterReading, offpeakMeterReading, isPending, isOMR, supplyIndex, readingDate, hasImgError, msn, meterPhotoName) {
    if (readingDate === void 0) { readingDate = ''; }
    var values = __assign({ fuel: fuel, peakMeterReading: peakMeterReading, offpeakMeterReading: offpeakMeterReading, readingDate: readingDate !== ''
            ? (0, date_fns_1.format)(new Date(readingDate), 'yyyy-MM-dd')
            : (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), 'yyyy-MM-dd'), isPending: isPending, isOMR: isOMR }, (supplyIndex ? { supplyIndex: supplyIndex } : {}));
    if (msn) {
        values.msn = msn;
    }
    if (meterPhotoName) {
        values.meterPhotoName = meterPhotoName;
    }
    if (hasImgError) {
        values.photoError = hasImgError;
    }
    return "".concat(basePath, "?") + params(values);
};
var getSuccessRedirectLink = function (basePath, data, fuel, isPending, isOMR, supplyIndex, hasImgError, readingDate, msn, meterPhotoName) {
    var _a;
    if (readingDate === void 0) { readingDate = ''; }
    if ('gasVolume' in data) {
        return toSingleRateRedirectLink(basePath, fuel, (_a = data.gasVolume) !== null && _a !== void 0 ? _a : 0, isPending, isOMR, supplyIndex, readingDate, hasImgError, msn, meterPhotoName);
    }
    else {
        if (data.tiers.length === 1) {
            var meterReading = data.tiers[0].meterRegisterReading;
            return toSingleRateRedirectLink(basePath, fuel, meterReading, isPending, isOMR, supplyIndex, readingDate, hasImgError, msn, meterPhotoName);
        }
        else if (data.tiers.length === 2) {
            var _b = __read(['peak', 'offpeak'].map(function (label) {
                var tier = data.tiers.find(function (t) { return t.timeOfUseLabel === label; });
                return tier && tier.meterRegisterReading;
            }), 2), peakReading = _b[0], offpeakReading = _b[1];
            if (!peakReading || !offpeakReading) {
                throw new Error('Expected peak and offpeak submission');
            }
            return toMultiRateRedirectLink(basePath, fuel, peakReading, offpeakReading, isPending, isOMR, supplyIndex, readingDate, hasImgError, msn, meterPhotoName);
        }
        else {
            throw new Error("Expected either 1 or 2 tiers, ".concat(data.tiers.length, " tiers given"));
        }
    }
};
exports.getSuccessRedirectLink = getSuccessRedirectLink;
var expectedErrorCodes = [
    'LOWER_THAN_PREVIOUS_READING',
    'CONSUMPTION_TOO_HIGH',
];
var allErrorsExpected = function (errors) {
    return errors.every(function (_a) {
        var errorCode = _a.errorCode, forceable = _a.forceable;
        return expectedErrorCodes.includes(errorCode) && forceable;
    });
};
exports.allErrorsExpected = allErrorsExpected;
function mapApiErrorCode(errorCode) {
    switch (errorCode) {
        case 'CONSUMPTION_TOO_HIGH':
            return SERVER_SIDE_ERRORS.TOO_HIGH;
        case 'NEGATIVE_READING':
        case 'LOWER_THAN_PREVIOUS_READING':
            return SERVER_SIDE_ERRORS.TOO_LOW;
        default:
            return FALLBACK_ERROR;
    }
}
exports.mapApiErrorCode = mapApiErrorCode;
var getMeterReadAnalyticsData = function (supply, fuel) { return ({
    fuel: fuel,
    isSmart: supply.isSmart,
    isNonComms: supply.isNonComms,
    isInOMRWindow: supply.isInOMRWindow,
    isOnboarding: supply.isOnboarding,
    msnData: !!supply.msn,
    mpxnData: !!supply.mpxn,
}); };
exports.getMeterReadAnalyticsData = getMeterReadAnalyticsData;
var ClientSideDateError;
(function (ClientSideDateError) {
    ClientSideDateError["Invalid"] = "errorsClientDateInvalid";
    ClientSideDateError["InFuture"] = "errorsClientDateInFuture";
    ClientSideDateError["TooFarInPast"] = "errorsClientDateTooFarInPast";
    ClientSideDateError["BeforeSupplyStart"] = "errorsClientDateBeforeSupplyStart";
    ClientSideDateError["BeforeMeterExchange"] = "errorsClientDateBeforeMeterExchange";
})(ClientSideDateError || (exports.ClientSideDateError = ClientSideDateError = {}));
var validateDate = function (date, // yyyy-mm-dd format, or any date-fns can parse correctly
supplyStartDate, meterExchangeDate) {
    // is date in correct format?
    var readingDate = (0, date_fns_1.parse)(date, 'yyyy-MM-dd', new Date());
    if (!(0, utils_1.isValidDate)(date)) {
        return { message: ClientSideDateError.Invalid, errorName: 'invalid-date' };
    }
    // is the parsed version actually a date?
    if (!(0, date_fns_1.isValid)(readingDate)) {
        return { message: ClientSideDateError.Invalid, errorName: 'invalid-date' };
    }
    var today = (0, date_fns_1.startOfToday)();
    if ((0, date_fns_1.isAfter)(readingDate, today)) {
        return { message: ClientSideDateError.InFuture, errorName: 'future-date' };
    }
    // more than 10 days ago
    if ((0, date_fns_1.isBefore)(readingDate, (0, date_fns_1.subDays)(today, 9))) {
        return {
            message: ClientSideDateError.TooFarInPast,
            errorName: 'date-over-10-days-ago',
        };
    }
    // before supply start
    if ((0, date_fns_1.isBefore)(readingDate, supplyStartDate)) {
        return {
            message: ClientSideDateError.BeforeSupplyStart,
            errorName: 'date-before-ssd',
        };
    }
    // before most recent meter exchange
    if (meterExchangeDate && (0, date_fns_1.isBefore)(readingDate, meterExchangeDate)) {
        return {
            message: ClientSideDateError.BeforeMeterExchange,
            errorName: 'date-before-mex',
        };
    }
    return null;
};
exports.validateDate = validateDate;
var getBackdatedDaysToToday = function (date) {
    if (date === '' || date.toLowerCase() === 'today') {
        return 0;
    }
    var _a = __read(date.split('/'), 3), day = _a[0], month = _a[1], year = _a[2];
    return Math.abs((0, date_fns_1.differenceInCalendarDays)(new Date(Number(year), Number(month) - 1, Number(day)), Date.now()));
};
exports.getBackdatedDaysToToday = getBackdatedDaysToToday;
var getReadingDateTime = function (date) {
    if (!date) {
        return '';
    }
    if (date.toLowerCase() === 'today') {
        return (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), 'yyyy-MM-dd');
    }
    var _a = __read(date.split('/'), 3), day = _a[0], month = _a[1], year = _a[2];
    return "".concat(year, "-").concat(month, "-").concat(day);
};
exports.getReadingDateTime = getReadingDateTime;
